import backendHttpRequest from "./backendHttpRequest";
import { config } from "../configs/repositoryConfig";
import { convertToQueryString } from "../utilities/httpUtils";
import { replaceAllStringByKeys } from "../utilities/stringUtils";

export const getSummerSchoolSpark = async (filteredObject) => {
  const queryString = convertToQueryString(filteredObject);
  const resourceObject = {
    ...config.backendApiSettings.resources.getSummerSchoolSpark,
  };
  const endpoint = resourceObject.endpoint;
  resourceObject.endpoint = `${endpoint}${
    queryString ? `?${queryString}` : ""
  }`;

  const apiUsers = await backendHttpRequest({ resourceObject });
  return apiUsers;
};

export const getSummerSchoolSparkById = async (id) => {
  const resourceObject = {
    ...config.backendApiSettings.resources.getSummerSchoolSparkById,
  };
  resourceObject.endpoint = replaceAllStringByKeys(
    resourceObject.endpoint,
    [":id"],
    [id]
  );

  const apiUser = await backendHttpRequest({ resourceObject });

  return apiUser;
};

export const updateSummerSchoolSparkStatus = async (id, status) => {
  const resourceObject = {
    ...config.backendApiSettings.resources.updateSummerSchoolSparkStatus,
  };
  const endpoint = resourceObject.endpoint;
  resourceObject.endpoint = `${endpoint}?${id}/${status}`;

  const apiUser = await backendHttpRequest({ resourceObject });

  return apiUser;
};

export const removeSummerSchoolSpark = async (id) => {
  const resourceObject = {
    ...config.backendApiSettings.resources.deleteSummerSchoolSpark,
  };
  const endpoint = resourceObject.endpoint;
  resourceObject.endpoint = endpoint.replace(":id", id);

  await backendHttpRequest({ resourceObject });

  return id;
};
